export default __webpack_public_path__ + "maps-examples-default-callout-1200-ac37de5dc1eba7592e83bbbfbc987f50.webp";